export var JobStatusEnum;
(function (JobStatusEnum) {
    JobStatusEnum["PENDING"] = "pending";
    JobStatusEnum["QUEUED"] = "queued";
    JobStatusEnum["RUNNING"] = "running";
    JobStatusEnum["COMPLETED"] = "completed";
    JobStatusEnum["FAILED"] = "failed";
    JobStatusEnum["DELAYED"] = "delayed";
    JobStatusEnum["CANCELED"] = "canceled";
    JobStatusEnum["MERGED"] = "merged";
    JobStatusEnum["SKIPPED"] = "skipped";
})(JobStatusEnum || (JobStatusEnum = {}));
export var DigestCreationResultEnum;
(function (DigestCreationResultEnum) {
    DigestCreationResultEnum["MERGED"] = "MERGED";
    DigestCreationResultEnum["CREATED"] = "CREATED";
    DigestCreationResultEnum["SKIPPED"] = "SKIPPED";
})(DigestCreationResultEnum || (DigestCreationResultEnum = {}));
